<template>
  <div class="columns my-2 is-gapless is-vcentered notification px-6 py-2" :style="{'background-color': backgroundColor}">
    <div class="column is-narrow">
      <b-icon :icon="stageIcon" class="has-text-grey" size="is-medium"></b-icon>
    </div>
    <div class="column"> 
      <div class="has-text-weight-bold is-size-6 has-text-centered" :class="statusColor">
        {{ stageName }} {{ statusMessage }}
        <!-- Loop through confirmationNumber array and display each -->
        <span v-if="cancellationNumbers.length > 0">
          <br/>
          Cancel Confirmation 
          <span v-for="(number, index) in cancellationNumbers" :key="index">
            #{{ number }}<span v-if="index !== cancellationNumbers.length - 1">, </span>
          </span>
        </span>
      </div>
    </div>
    <div class="column is-narrow">
      <b-icon :icon="statusIcon" :class="statusColor" class="px-2" size="is-medium"></b-icon>
    </div>
  </div>
</template>

  
  <script>
  export default {
    name: "CancellationStageStatus",
    components: {},
    props: {
      stage: Object,
    },
    data: function() {
      return {};
    },
    computed: {
      backgroundColor() {
          return this.stage.isComplete ? '#def5e3' : '#ffede9';       
      },
      statusIcon() {
          return this.stage.isComplete ? 'check-circle' : 'alert-circle';
      },
      statusColor() {
          return this.stage.isComplete ? 'has-text-success' : 'has-text-danger';
      },
      statusMessage() {
          return this.stage.isComplete ? 'success.' : 'failed.';
      },
      stageName(){
          let name = '';
          if(this.stage.slug === 'air'){
              name = 'Flight cancellation';
          } else if(this.stage.slug === 'car'){
              name = 'Car cancellation';
          } else if(this.stage.slug === 'hotel'){
              name = 'Hotel cancellation';
          }
          return name;
  
      },
      stageIcon() {
        let icon = "";
        if (this.stage.slug === "air") {
          icon = "airplane-takeoff";
        } else if (this.stage.slug === "car") {
          icon = "car";
        } else if (this.stage.slug === "hotel") {
          icon = "bed";
        }
          return icon;
      },
      cancellationNumbers(){
        return this.stage.cancellationNumbers || [];
      }
    },
  };
  </script>
  
  <style></style>
  